export default "__VITE_ASSET__CxmZ73RI__"